export default "__VITE_ASSET__D4QXf952__"